export default __webpack_public_path__ + "static/media/IconDesc_TurboMotor.256.0e9556e5.png";